/* eslint-disable header/header */
export const name = "@azure/msal-common";
export const version = "13.3.0";
